import React from "react"
import Navbar from "../../../../Common/Navbar"
import Footer from "../../../../Common/Footer"
import Sidebar from "../../../../Sidebar/Sidebar"
import EnquiryDashboardComp  from "./Component/EnquiryDashboardComp"

const EnquiryDashboard =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <EnquiryDashboardComp />
        </div>
        <Footer />
        </>
    )
}

export default EnquiryDashboard;